<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.logradouro"
        ref="DataTable"
        sort-by="logradouroTipoDescricao"
    >
        <template v-slot:cell(cep)="row">
            {{ row.value | formatCep}}
        </template>

        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                color="primary"
                title="Selecioner logradouro"
                small
                @click.stop="handleLogradouro(item)"
            >
                <rkm-icon icon="check" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>

// Mixins.
import { repository, error } from '@/mixins'

// Filters.
import formats from '@/filters/formats'

// Vuex.
import { mapActions } from 'vuex'

export default {
    mixins: [
        repository,
        error,
    ],
    filters: {
        ...formats,
    },
    data: () => ({
        repositories: {
            logradouro: null,
        },
        fields: [
            {
                name: 'nome',
                key: 'nome',
                label: 'Logradouro',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroLogradouroTipo.descricao',
                key: 'logradouroTipoDescricao',
                label: 'Tipo',
                class: 'col-min',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroBairro.nome',
                key: 'bairroNome',
                label: 'Bairro',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroMunicipio.nome',
                key: 'municipioNome',
                label: 'Município',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroEstado.uf',
                key: 'estadoUf',
                label: 'UF',
                searchable: true,
                sortable: true,
                class: 'col-min'
            },
            {
                name: 'actions',
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
    }),
    created() {
        this.repositories.logradouro = this.getConectaSusRepository('cadastro.localizacao.logradouro')
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleLogradouro(item) {
            this.setLoading()

            this.repositories.logradouro.show(item.id)
                .then(({ data }) => {
                    this.$emit('select', data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    }
}
</script>